// extracted by mini-css-extract-plugin
export default {"backBtn":"GoToButton_backBtn__C9pj5","arrowLeft":"GoToButton_arrowLeft__Um0p7","goToBtn":"GoToButton_goToBtn__yDOKB","arrowRight":"GoToButton_arrowRight__uHhoH"};